import React from 'react'

const SubHeader = ({ children }) => {
    return (
        <div className='bg-[#171928] w-full'>
            {children}
        </div>
    )
}

export default SubHeader